import React from 'react';
import { BellRinging } from '@phosphor-icons/react';
import { L, CAT_LABEL, fmtDateTime } from './shared';

export const AttentionList = ({ rows, lang, onOpen }) => {
  if (!rows.length) return null;
  return (
    <div className="mt-4 border border-orange-300 bg-orange-50/60" data-testid="of-attention-list">
      <div className="px-3 py-2 flex items-center gap-2 text-sm font-semibold text-orange-900 border-b border-orange-200">
        <BellRinging size={16} />{L(lang, 'Απαιτείται ενέργεια διαχείρισης', 'Management action required')} ({rows.length})
        <span className="text-[11px] font-normal text-orange-800">{L(lang, '— τα παλαιότερα αναπάντητα πρώτα', '— oldest unanswered first')}</span>
      </div>
      {rows.map((r) => (
        <div key={r.response_id} className="px-3 py-2 border-t border-orange-100 flex flex-wrap items-start gap-3 text-xs" data-testid={`of-attn-${r.response_id}`}>
          <div className="min-w-[220px]">
            <div className="font-semibold">{r.building_name} · {L(lang, 'Διαμ.', 'Apt')} {r.apartment_number}</div>
            <div className="text-zinc-600">{r.owner_name || '—'} · {r.title || CAT_LABEL[lang][r.category] || r.category}</div>
            <div className="text-[10px] text-orange-800 mt-0.5">{r.messages_count > 1 && r.last_message_from === 'owner' ? L(lang, 'Νέα απάντηση ιδιοκτήτη', 'New owner reply') : L(lang, 'Νέο αίτημα', 'New request')} · {fmtDateTime(r.owner_waiting_since || r.submitted_at)}</div>
          </div>
          <div className="flex-1 min-w-[200px] text-zinc-700 whitespace-pre-wrap line-clamp-2">{r.last_message_text}</div>
          <button type="button" onClick={() => onOpen(r)} className="bg-zinc-900 text-white px-3 py-1.5 font-semibold hover:bg-zinc-700 transition-colors" data-testid={`of-attn-open-${r.response_id}`}>{L(lang, 'Προβολή & Απάντηση', 'View & Reply')}</button>
        </div>))}
    </div>
  );
};

export default AttentionList;
